export interface ConfigFormValues {
  communicationId: number | null
  maxPerWindow: number | null
  windowSeconds: number | null
}

export function isConfigFormValid(
  form: ConfigFormValues,
  isEditing: boolean,
): boolean {
  if (!isEditing && !form.communicationId) return false
  if (form.maxPerWindow === null || form.maxPerWindow < 0) return false
  return !!form.windowSeconds
}
